// Research breakthroughs (art audit P6) — español. Se une en ./messages.ts.

export const gameResearchEs = {
  'research.breakthrough': '¡Un avance!',
  'research.breakthrough.sub':
    'Tus eruditos terminan su obra: los bonos se desvanecen con la hazaña.',
} as const;
